const ENQUIRY_DELETED = 'Enquiry deleted',
    LS_DELETED = 'LS deleted',
    DELETED = 'Deleted';

export {
    ENQUIRY_DELETED,
    LS_DELETED,
    DELETED
}
